import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { LastStatusBlockProps } from "./types";

export function LastStatusPanelRenderer(blockProps: LastStatusBlockProps) {
  return (
    <PanelContainer blockProps={blockProps}>
      <PanelBlockAlignment />
      <PanelTranslationState mode="auto" portal />
    </PanelContainer>
  );
}
